import { combineReducers } from 'redux';
import { NewsState } from 'models/state/news';
import { reducer as psReducer } from './products-services';
import { reducer as sdReducer } from './skill-development';

export const newsReducer = combineReducers<NewsState>({
    productsServices: psReducer,
    skillDevelopment: sdReducer
});